import { render, staticRenderFns } from "./userIntegral.vue?vue&type=template&id=4a36a4b8&scoped=true&"
import script from "./userIntegral.vue?vue&type=script&lang=js&"
export * from "./userIntegral.vue?vue&type=script&lang=js&"
import style0 from "./userIntegral.vue?vue&type=style&index=0&id=4a36a4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36a4b8",
  null
  
)

export default component.exports